import React from 'react';
import { showNotification } from 'react-admin';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { exerciseToggleApprove } from './exerciseActions';

class ToggleApproveButton extends React.Component {
  state = {
    loading: false,
  };

  handleClick = () => {
    const { record, toggleApprove } = this.props;
    toggleApprove(record.id, record);
  };

  render() {
    const { record } = this.props;
    const { loading } = this.state;
    return (
      <Button variant="flat" color="primary" onClick={this.handleClick} disabled={loading}>
        {record.approved ? 'Invalidate' : 'Approve'}
      </Button>
    );
  }
}

export default connect(
  null,
  {
    showNotification,
    toggleApprove: exerciseToggleApprove,
  },
)(ToggleApproveButton);



// WEBPACK FOOTER //
// ./src/resources/exercises/ToggleApproveButton.jsx